/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'avi-forms';
const componentName = 'credentials-verification-dialog';
const prefix = `${moduleName}.${componentName}`;

export const cancelButtonLabel = `${prefix}.cancelButtonLabel`;
export const connectButtonLabel = `${prefix}.connectButtonLabel`;

export const ENGLISH = {
    [cancelButtonLabel]: 'Cancel',
    [connectButtonLabel]: 'Connect',
};
